<template>
  <Category
    cate-name="bythem"
    category-name="by them賞"
    category-intro="多様な悩みに寄り添うWebメディア「by them」が厳選。心の中のモヤモヤがかたちになって、読めば少し、気持ちが軽くなる。そんなメルマガをセレクトしました。"
  />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
